import * as React from 'react';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { ClientLogger } from 'bernie-client';

const loggerWithId = ClientLogger.getLoggerWithIdentifier('pwa.component.amenitylistitem');

export interface AmenityListItemProps {
  item:
    | string
    | {
        description: string;
      };
  type: string;
}

export const AmenityListItem: React.FunctionComponent<AmenityListItemProps> = ({ item, type }) => {
  const description = determineDescription(item);
  if (!description) {
    return null;
  }

  return <li className={`amenity-${type}__list--item`}>{description}</li>;
};

const determineDescription = item => {
  if (typeof item === 'string') {
    return item;
  } else if (item && item.description && typeof item.description === 'string') {
    return item.description;
  }

  loggerWithId.logEvent(
    new SystemEvent(SystemEventLevel.ERROR, 'AMENITY_LIST_ITEM_DETERMINE_DESCRIPTION'),
    `Amenity List Item without description: ${JSON.stringify(item)}`
  );

  return null;
};
